import {
  SET_STREAM,
  SET_VIDEO_CONTROLLED,
  SET_VIDEO_DISPLAY,
  SET_CAPTIONS_DISPLAY,
  SET_AUDIO_SETTING,
  GOT_CAPTIONS,
  GET_SERVER_TIME,
  SET_SERVER_TIME,
  SET_PACKET_LOST,
  SET_NUM_VIEWERS,
  SHOW_SET_VIDEO_DISPLAY,
  SET_FRAME_RATE,
  SET_TOTAL_PACKETS_VIDEO,
  SET_TOTAL_PACKETS_AUDIO,
  SET_BITRATE_SENT
} from 'types/actions/stream'
import update from 'immutability-helper'

const streamInitalState = {
  name: '',
  nameDialogOpen: false,
  currentVideoReady: false,
  cloudinaryVideoControlled: false,
  egLiveVideoControlled: false,
  displayVideo: true,
  captions: false,
  captionText: '',
  audioSetting: false,
  gotCaptions: false,
  servertime: '',
  packetLost: '',
  showDisplayVideo: true
}

export default (state = streamInitalState, action) => {
  switch (action.type) {
    case SET_STREAM:
      return {
        ...state,
        ...action.data
      }
    case SET_VIDEO_CONTROLLED:
      console.log('SET_VIDEO_CONTROLLED reducer:', { videoType: action.videoType, controlled: action.controlled });
      return update(state, {
        [`${action.videoType}VideoControlled`]: {
          $set: action.controlled
        }
      })
    case SET_VIDEO_DISPLAY:
      console.log('SET_VIDEO_DISPLAY reducer:', { displayVideo: action.displayVideo });
      return update(state, {
        displayVideo: {
          $set: action.displayVideo
        }
      })
    case SET_CAPTIONS_DISPLAY:
      return update(state, {
        captions: {
          $set: action.captions
        }
      })
    case SET_AUDIO_SETTING:
      return update(state, {
        audioSetting: {
          $set: action.audioSetting
        }
      })
    case GOT_CAPTIONS:
      return update(state, {
        gotCaptions: {
          $set: action.gotCaptions
        }
      })
    case SET_SERVER_TIME:
      return update(state, {
        servertime: {
          $set: action.servertime
        }
      })
    case SET_PACKET_LOST:
      return update(state, {
        packetLost: {
          $set: action.packetLost
        }
      })
    case SET_NUM_VIEWERS:
      return update(state, {
        numViewers: {
          $set: action.numViewers
        }
      })
    case SHOW_SET_VIDEO_DISPLAY:
      return update(state, {
        showDisplayVideo: {
          $set: action.showDisplayVideo
        }
      })
    case SET_FRAME_RATE:
      return update(state, {
        frameRate: {
          $set: action.frameRate
        }
      })
    case SET_TOTAL_PACKETS_VIDEO:
      return update(state, {
        totalVideoPackets: {
          $set: action.totalVideoPackets
        }
      })
    case SET_TOTAL_PACKETS_AUDIO:
      return update(state, {
        totalAudioPackets: {
          $set: action.totalAudioPackets
        }
      })
    case SET_BITRATE_SENT:
      return update(state, {
        bitrateSent: {
          $set: action.bitrateSent
        }
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/stream.js